/*
 * Copyright (c) 2019 Frontier Developments PLC.
 */

import {Component, Vue} from 'vue-property-decorator';
import {Action} from 'vuex-class';
import {AudioApiCallInterface} from '@/store/modules/game/types';

/**
 * Scroll  mixin.
 * Provides common functionality for scrolling across different views.
 * @author Jonny Cook <jcook@frontier.co.uk>
 */
@Component
export default class Scroll extends Vue {
    public readonly SCROLL_WAIT: number = 75;

    @Action('callAudioApi', {namespace: 'gameModule'})
    public callAudioApi!: (audioApiCall: AudioApiCallInterface) => void;

    public lastScroll: number = 0;

    /**
     * Applies the audio scroll event every time period.
     */
    public scroll(): void {
        const timestamp: number = Date.now();
        if ((timestamp - this.lastScroll) < this.SCROLL_WAIT) {
            return;
        }

        this.lastScroll = timestamp;
        this.callAudioApi({type: 'updateDrag'});
    }
}

